import styled from 'styled-components';

export const Container = styled.div`
`

export const StatusContainer = styled.div`
`

export const StatusText = styled.div`
`

export const StatusDetails = styled.div`
  color: #999;
  word-wrap: break-word;
`

export const OptionsContainer = styled.div`
  margin-top: 5px;
  padding-top: 10px;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: center;
`;